export const environment = {
  production: false,
  apiBaseUrl: 'https://api-gateway.tegalhub.com/preprod-api-icamo-yonewi/yonewi-fhir/v1/api/v1/fhir',
  authUrl: 'https://api-gateway.tegalhub.com/preprod-api-icamo-yonewi/backend/v1',
  minIo: {
    baseUrl: 'https://api-doc.front.tegalhub.com/api-document-management/api-documents',
    accessKey: 'oCqQLokVtA3omqI6gUEE',
    secretKey: 'Zc4Tin8dIOSFfn7qvpT4fltLRAe2qc9eFuLfoLzi',
    bucketName: 'icamo'
  }
};
